import { Button, IconButton, Tooltip } from "@mui/material";

export const CustomIconButton = (props) => {
  const {
    children,
    onClick,
    disabled = false,
    color = "rgb(95, 99, 104)",
    tooltip = "",
    ariaLabel,
    type = "icon",
    fontSize = 15,
    text = "",
  } = props;

  const handleClick = (e) => {
    e.stopPropagation(); // ⭐ 부모로 이벤트 전파 차단
    onClick?.(e);
  };

  const stop = (e) => {
    e.stopPropagation();
  };

  if (type === "icon") {
    return (
      <Tooltip
        title={tooltip}
        arrow
      >
        <span
          style={{
            display: "inline-flex", // inline-block 대신
            width: `${fontSize}px`,
            height: `${fontSize}px`,
            lineHeight: 0, // baseline 여백 제거
            verticalAlign: "middle", // 주변 텍스트와 정렬 안정화
          }}
        >
          <IconButton
            aria-label={ariaLabel}
            sx={{
              color,
              fontSize,
              width: "auto",
              height: "auto",
              minWidth: "unset",
              minHeight: "unset",
              padding: 0,
              lineHeight: 1, // 버튼 자체 높이가 children에 맞게 줄어듦
            }}
            onClick={handleClick}
            disabled={disabled}
            onMouseDown={stop}
            onMouseUp={stop}
          >
            {children}
          </IconButton>
        </span>
      </Tooltip>
    );
  } else if (type === "texticon") {
    return (
      <Button
        sx={{ px: 1, fontSize: 11 }}
        onClick={handleClick}
        disabled={disabled}
        color="primary"
        component="label"
        role={undefined}
        variant="contained"
        tabIndex={-1}
        onMouseDown={stop}
        onMouseUp={stop}
      >
        {text}
      </Button>
    );
  }
};
